import { makeTheme } from 'bootstrap-styled/lib/theme';
import debug from '../services/debug';
import variables from './variables';


const sfwTheme = makeTheme(variables);
debug('theme', sfwTheme);

export default sfwTheme;
